<template>
  <v-layout row wrap my-3 mx-2>
    <v-dialog
      v-model="ldialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-flex xs6 px-2>
      <v-card class="pa-2 mb-5 elevation-6">
        <v-card-title class="headline white--text primary" >
          Generate a page
        </v-card-title>
        <v-layout row wrap px-2 pt-2>
          <v-flex xs12 px-1>
            <v-select
              :items="savedPages"
              v-model="selectedPage"
              label="Load a saved Landing Page"
              append-outer-icon="add"
              @click:append-outer="newTemplate"
              solo
              :loading="loading"
              return-object
            ></v-select>
          </v-flex>
          <v-flex xs12 px-1>
            <v-text-field
              label="Landing Page Name"
              solo
              :loading="loading"
              return-object
              v-model="lpName"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 px-1>
            <v-select
              :items="defaultPages"
              label="Landing Pages"
              solo
              :loading="loading"
              return-object
              v-model="selectedDefaultPage"
              append-outer-icon="add"
              @click:append-outer="addDefaultPage()"
            ></v-select>
          </v-flex>
          <v-flex xs12 px-1>
            <v-select
              :items="brands"
              label="Brand"
              solo
              :loading="loading"
              return-object
              v-model="selectedBrand"
              append-outer-icon="add"
              @click:append-outer="addBrand()"
            ></v-select>
          </v-flex>
          
          <v-flex xs12 px-1>
            <v-text-field
              label="CTA Text"
              solo
              :loading="loading"
              v-model="cta"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 px-1>
            <v-text-field
              label="UTM Campaign"
              solo
              :loading="loading"
              v-model="campaign"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 px-1>
            <v-text-field
              label="UTM Content"
              solo
              :loading="loading"
              v-model="content"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 px-1>
            <v-text-field
              label="UTM Referrer"
              solo
              :loading="loading"
              v-model="referrer"
            ></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-btn
              :disabled="!referrer || !lpName || !selectedDefaultPage || !selectedBrand || !cta || !campaign || !content"
              color="primary" 
              :loading="loading"
              @click="generateShortLink()"
            >
              generate 
            </v-btn>
          </v-flex>
          <v-flex xs7 px-1>
            <v-text-field
              label="Short Link"
              solo
              readonly
              v-model="shortLink"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-btn
              v-clipboard:copy="shortLink"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
              :disabled="!shortLink" fab small outline color="primary" >
              <v-icon>file_copy</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-actions class="px-3">
          <v-spacer></v-spacer>
          <v-btn 
            outline 
            color="error" 
            dark
            v-if="selectedPage"
            @click="dialog = true"
          >delete template</v-btn>
          
          <v-btn 
            @click="saveTemplate()"  
            color="primary" 
            :loading="loading"
            dark>
            {{ selectedPage ? 'Update' : 'Save Template'}}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="dialog" persistent max-width="390">
        <v-card>
          <v-card-title class="headline">Are You Sure?</v-card-title>
          <v-card-text>
            You are about to delete template {{ lpName }}, are you sure you want to do that?
            <div class="error white--text pa-2 ma-3">NOTE: all data associated with template {{ lpName }} will be deleted completely from our servers, and it will be impossible to restore it</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="dialog = false">cancel</v-btn>
            <v-btn 
              color="success" 
              outline 
              @click="()=>{ deleteTemplate(); dialog = false  }"
            >confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog -->
      <!-- dialog -->
      <!-- dialog -->

    </v-flex>
    <v-flex xs6  px-2 ref="container">
      <v-card
        class="pa-2 mb-5 elevation-6"
      >
        <v-card-title class="headline white--text primary" >
          Preview
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs10>
            <v-text-field
              label="Short URL"
              v-model="shortLink"
              solo
              hide-details
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-btn
              v-clipboard:copy="shortLink"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
              fab small outline color="primary" :disabled="!shortLink">
              <v-icon>file_copy</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        
        <div
          class="iframeWrapper browser"
          ref="iframeWrapper"
          v-on:dragstart="getRight()" 
          @click.right="getRight()" 
          @click.left="getRight()"
        >
            <div class="browser-navigation-bar">
            <i></i><i></i><i></i>
            <input :value="getLong" disabled />
            </div>
          <div class="browser-container">
          <iframe
          v-on:dragstart="getRight()" 
          @click.right="getRight()" 
          @click.left="getRight()"
          class="frame" :style="frameStyle" ref="frame" :src="getLong" frameborder="0"></iframe>
          </div>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Papa from 'papaparse'
import axios from 'axios';
import { uuid } from '@/customFunction';
import { storageRef, firebase, db, auth } from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';


export default {
  data() {
    return {
      loading:false,
      ldialog:false,
      savedPages:[],
      selectedPage:null,
      defaultPages:[],
      selectedDefaultPage:null,
      brands:[],
      selectedBrand:null,
      loadedLinks:null,
      selectedKey:null,
      lpName:null,
      cta:null,
      campaign:null,
      content:null,
      referrer:null,
      dialog:false,
      frameStyle:null,
      wWidth:null,
      windowWidth:null, 
      shortLink:null,
      shortLinkCopy :null,
    }
  },
  methods: {
    addDefaultPage(){
      
    },
    addBrand(){
      
    },
    getWH(){
      let w = this.$refs.iframeWrapper.clientWidth;
      let f = this.$refs.frame.clientWidth;
      let c = this.$refs.container.clientWidth;
      this.wWidth = w
      let n = w * 100 / 40
      this.frameStyle = `width:${n}px;`
    },
    getRight(e) {
      e = e || window.event;
      e.preventDefault()
    },
    deleteTemplate() {
      if(!this.selectedKey) return true
      db.ref('lp/savedLps')
      .update({[this.selectedKey]:null})
      .then(y=>{
        let index = this.loadedLinks.findIndex(x => x.value === this.selectedKey)
        console.log(index)
        this.loadedLinks.splice(index, 1)
        this.newTemplate()
      })
    },
    getData(){
      db.ref('lp/lps')
      .on('value', t=>{
        let defaultPages = t.val()
        for (const key in defaultPages) {
            if (defaultPages.hasOwnProperty(key)) {
              const template = defaultPages[key];
              this.defaultPages.push({
                text:template.name.toUpperCase(),
                value:key,
                url:template.logo
              })
            }
        }
      })
      db.ref('lp/brands')
      .on('value', t=>{
        let brands = t.val()
        for (const key in brands) {
            if (brands.hasOwnProperty(key)) {
              const template = brands[key];
              this.brands.push({
                text:template.name.toUpperCase(),
                value:key,
                url:template.logo
              })
            }
        }
      })
      db.ref('lp/savedLps')
      .on('value', t=>{
        let savedPages = t.val()
        this.loadedLinks = savedPages
        for (const key in savedPages) {
            if (savedPages.hasOwnProperty(key)) {
              const template = savedPages[key];
              this.savedPages.push({
                text:template.name.toUpperCase(),
                value:key,
                url:template.url
              })
            }
        }
      })
    },
    saveTemplate(){
      let template = {
        name:this.lpName,
        url:this.selectedDefaultPage.url,
        brand:this.selectedBrand.url,
        cta:this.cta,
        campaign:this.campaign,
        content:this.content,
        referrer:this.referrer,
        shortLink:this.shortLink
      }
      console.log(template)
      if(!this.selectedKey) {
        db.ref('lp/savedLps')
        .push(template)
        .then(x=>{
          this.newTemplate()
        })
      } else {
        db.ref('lp/savedLps/' + this.selectedKey)
        .update(template)
        .then(x=>{
          this.newTemplate()
        })
      }
    },
    generateShortLink() {
      this.loading = true
      this.ldialog = true
      let url = `${this.selectedDefaultPage ? this.selectedDefaultPage.url : ''}/?cta=${this.cta}&logo=${this.selectedBrand ? this.selectedBrand.url : ''}&UtmCampaign=${this.campaign}&UtmContent=${this.content}&Referrer=${this.referrer}`
      let id = uuid()
      let dataObj = {
        url: url,
        action: 'generate_link',
        id: id
      }
      var headers = {
        'Accept': 'application/json'
      }
      axios.post('http://s.4w7pc5z8gc.com/api/', JSON.stringify(dataObj), {headers: headers})
      .then(resp=>{
        console.log('------------------------------------');
        console.log(resp.data);
        console.log('------------------------------------');
        let dataObj2 = {
          action: 'get_shortlink',
          id: id
        }
        setTimeout(i=>{
          axios.post('http://s.4w7pc5z8gc.com/api/', JSON.stringify(dataObj2), {headers: headers})
          .then(resp=>{
            console.log(resp.data);
            this.shortLink = resp.data.short.short_link
            this.shortLinkCopy = this.shortLink
            this.loading = false
            this.ldialog = false
          })
        }, 2000)
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    newTemplate(){
      this.selectedPage = null
      this.lpName = null
      this.cta = null
      this.selectedDefaultPage = null
      this.selectedBrand = null
      this.campaign = null
      this.content = null
      this.referrer = null
      this.shortLink = null
      this.selectedKey = null
      this.shortLinkCopy = this.shortLink
    }
  },
  computed:{
    getLong() {
      return `${this.selectedDefaultPage ? this.selectedDefaultPage.url.replace('http:','') : ''}/?cta=${this.cta}&logo=${this.selectedBrand ?this.selectedBrand.url.replace('http:','') : ''}&UtmCampaign=${this.campaign}&UtmContent=${this.content}&Referrer=${this.referrer}`
      return true
    },
    shortLinkCopy(){
      let m = this.shortLinkCopy
      let x = this.shortLink
      return this.shortLinkCopy
    }
  },
  watch:{
    windowWidth() {
      console.log('WW')
      this.getWH()
    },
    selectedPage() {
      if (!this.selectedPage) return
      let t = this.loadedLinks[this.selectedPage.value]
      this.lpName = t.name
      this.cta = t.cta
      this.selectedDefaultPage = this.defaultPages.filter(x=> x.url == t.url)[0]
      console.log(this.selectedDefaultPage);
      this.selectedBrand = this.brands.filter(x=> x.url == t.brand)[0]
      this.campaign = t.campaign
      this.content = t.content
      this.shortLink = t.shortLink
      this.referrer = t.referrer
      this.selectedKey = this.selectedPage.value
      this.shortLinkCopy = this.shortLink
    }
  },

  created() {
    this.getData() 
    let DB = (ref) => {
      return db.ref(ref)
      .once('value')
      .then(x=>{ return x.val()})
    } 
    DB('whatsapp/numbers').then(e=>{
      console.log(e)
    })

  },
  mounted(){
    this.getWH()
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      });
    })
  }
}
</script>

<style scoped>
.iframeWrapper {
  width: 100%
}
.frame { width: 1600px; height: 1600px;}

.frame {
    /* zoom: 0.50; */
    -moz-transform: scale(0.4);
    -moz-transform-origin: 0 0;
    -o-transform: scale(0.4);
    -o-transform-origin: 0 0;
    -webkit-transform: scale(0.4);
    -webkit-transform-origin: 0 0;
}
.browser {
  font-size: 18px;
	padding: 2.1em 0 0 0;
	border-radius: 0.25em;
	background: #ddd;
	display: inline-block;
	position: relative;
  overflow: hidden;
  box-shadow: 0 0.25em 0.9em -0.1em rgba(0,0,0,.3);
}

.browser .browser-navigation-bar {
	display: block;
  box-sizing: border-box;
	height: 2.1em;
	position: absolute;
	top: 0;
  padding: 0.3em;
  width: 100%;
  background: linear-gradient(to bottom, #edeaed 0%, #dddfdd 100%);
  border-bottom: 2px solid #cbcbcb;
}
 
.browser i {
  display: inline-block;
	height: 0.7em;
	width: 0.7em;
	border-radius: 0.45em;
	background-color: #eee;
	margin: 0.4em 0.15em;
}

.browser i:nth-child(1) {background-color: rgb(255, 86, 79)}

.browser i:nth-child(1):hover {background-color: rgb(255, 20, 25)}

.browser i:nth-child(2) {background-color: rgb(255, 183, 42)}

.browser i:nth-child(2):hover {background-color: rgb(230, 175, 42)}

.browser i:nth-child(3) {background-color: rgb(37, 198, 58)}

.browser i:nth-child(3):hover {background-color: rgb(10, 225, 10)}

.browser input {
  font-size: 0.75em;
  vertical-align: top;
  display: inline-block;
	height: 1.6em;
  color: #aaa;
	width: calc(100% - 6em);
  border: 0.1em solid #E1E1E1;
	border-radius: 0.25em;
	background-color: #eee;
  margin: 0.1em;
  padding: 0 0.4em;
}

.browser-container {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  
  text-align: center;
}
</style>
